const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordAuthenticator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Using Passowrd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.25,134.54c-.89,0-1.79-.27-2.54-.78-32.87-22.11-51.86-55.16-52.13-90.69-.02-2.08,1.38-3.91,3.39-4.44l50.12-13.3c.76-.2,1.56-.2,2.34,0l50.12,13.3c2.01.54,3.39,2.37,3.39,4.44-.25,35.5-19.26,68.57-52.13,90.69-.78.51-1.67.78-2.57.78ZM81.8,46.53c1.38,30.21,17.76,58.31,45.46,77.92,27.69-19.61,44.07-47.71,45.46-77.92l-45.46-12.07-45.46,12.07Z",
    style: {
      fill: "#3575bb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.38,80.06c0-6.76,0-10.13,2.1-12.23,2.1-2.1,5.48-2.1,12.23-2.1h19.11c6.76,0,10.13,0,12.23,2.1,2.1,2.1,2.1,5.48,2.1,12.23s0,10.13-2.1,12.23-5.48,2.1-12.23,2.1h-19.11c-6.76,0-10.13,0-12.23-2.1s-2.1-5.48-2.1-12.23Z",
    style: {
      fill: "none",
      stroke: "#6a489d",
      strokeMiterlimit: 133.33,
      strokeWidth: "3.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.93,65.73v-4.78c0-7.92,6.42-14.33,14.33-14.33s14.33,6.42,14.33,14.33v4.78",
    style: {
      fill: "none",
      stroke: "#6a489d",
      strokeLinecap: "round",
      strokeMiterlimit: 133.33,
      strokeWidth: "3.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.71,80.06h.02M127.24,80.06h.02M136.8,80.06h.02",
    style: {
      fill: "none",
      stroke: "#6a489d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.78px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 157.19,
    width: 224.53,
    height: 67.63,
    rx: 33.81,
    ry: 33.81,
    style: {
      fill: "none",
      stroke: "#3575bb",
      strokeMiterlimit: 133.33,
      strokeWidth: "3.42px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.11,
    y: 164.12,
    width: 210.31,
    height: 53.76,
    rx: 26.88,
    ry: 26.88,
    style: {
      fill: "none",
      stroke: "#6a489d",
      strokeMiterlimit: 133.33,
      strokeWidth: "2.95px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.87,182.95l-1.14,6.31,4.19-4.04,2.79,4.5-5.23,1.97,5.23,1.55-2.79,4.4-4.19-3.78,1.14,6.21h-5.43l1.19-6.31-4.24,3.88-2.79-4.4,5.12-1.4-5.12-2.12,2.79-4.5,4.24,3.93-1.19-6.21h5.43Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.92,182.95l-1.14,6.31,4.19-4.04,2.79,4.5-5.23,1.97,5.23,1.55-2.79,4.4-4.19-3.78,1.14,6.21h-5.43l1.19-6.31-4.24,3.88-2.79-4.4,5.12-1.4-5.12-2.12,2.79-4.5,4.24,3.93-1.19-6.21h5.43Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.96,182.95l-1.14,6.31,4.19-4.04,2.79,4.5-5.23,1.97,5.23,1.55-2.79,4.4-4.19-3.78,1.14,6.21h-5.43l1.19-6.31-4.24,3.88-2.79-4.4,5.12-1.4-5.12-2.12,2.79-4.5,4.24,3.93-1.19-6.21h5.43Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.01,182.95l-1.14,6.31,4.19-4.04,2.79,4.5-5.23,1.97,5.23,1.55-2.79,4.4-4.19-3.78,1.14,6.21h-5.43l1.19-6.31-4.24,3.88-2.79-4.4,5.12-1.4-5.12-2.12,2.79-4.5,4.24,3.93-1.19-6.21h5.43Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.06,182.95l-1.14,6.31,4.19-4.04,2.79,4.5-5.23,1.97,5.23,1.55-2.79,4.4-4.19-3.78,1.14,6.21h-5.43l1.19-6.31-4.24,3.88-2.79-4.4,5.12-1.4-5.12-2.12,2.79-4.5,4.24,3.93-1.19-6.21h5.43Z",
    style: {
      fill: "#231f20"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordAuthenticator);
export default __webpack_public_path__ + "static/media/password-authenticator.7b66320d74d6275ff08d5e763fe999d4.svg";
export { ForwardRef as ReactComponent };